<template>
  <div>
    <div class="multiactions" v-if="choosenChats.length && !isAdmin">
      <div class="multiheader">
        <h4>ausgewählt:</h4>
        <div>  <span><i class="fa fa-close"
                        @click="closeMultiAction"></i></span></div>
      </div>
      <div class="choosenCustomers">
        <div v-for="(chat, index) in choosenChats">
          <div class="choosenItem">
                        <span><i class="fa fa-close"
                                 @click="removeChat(chat, index)"></i>{{ chat.fullCustomerName }}</span>
          </div>
        </div>
      </div>
      <multiselect @closeOverlay="choosenChats = []"
                   :options="actions" selectedLabel="ausgewählt"
                   selectLabel="auswählen"
                   v-model="action"
                   placeholder="Aktion auswählen" label="name"
                   :close-on-select="true"
                   track-by="action" deselectLabel="Klicken zum Entfernen"></multiselect>
      <GroupOverlay @error="setError" @success="setSuccess"
                    @update-chats="updateChats" v-if="action && action.action === 'group'"
                    :clientGroups="clientGroups"
                    :chats="choosenChats">
      </GroupOverlay>
      <button v-if="action && action.action !== 'group'" type="button" class="btn btn-success"
              @click="multiAction">
        {{ action.name }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>

    <Chatcontrols :page-size="pageSize" :allClientMessages="allClientMessages" :currentPage="currentPage"
                  @prevpage="prevPage" @nextpage="nextPage"
                  @overlayChecked="overlayChecked = !overlayChecked" v-if="allClientMessages.length"></Chatcontrols>

    <div class="table" v-if="allClientMessages.length">
      <Tableheader :userGroups="userGroups" :allClientMessages="allClientMessages"></Tableheader>
      <div class="tableContent">
        <div v-for="(singleChat, index) in sortedClientChats" :key="singleChat.id" class="chatItem chatOverlay"
             :class="{highlight: singleChat.selected, chatOverlay: singleChat.showOverlay}"
             @click="handleClick(singleChat)">

          <div class="overlay chat" v-if="singleChat.showOverlay">
            <div class="messages" v-chat-scroll="{always: false, smooth: false}">
              <div class="overlay__headline">
                <p v-if="singleChat.messages">Chatvorschau</p>
                <p v-else>In diesem Chat existieren bisher noch keine
                  Nachrichten.</p>
              </div>
              <div class="chat-history">
                <Message v-for="message in singleChat.messages" :key="message.id" @error="setError"
                         @success="setSuccess" :message="message"
                         :currentChat="singleChat"></Message>
              </div>
            </div>
          </div>

          <div>
            <div v-html="highlight(singleChat.fullCustomerName)">
            </div>
            <i v-if="hasWatchers(singleChat)"
               class="fa fa-eye" aria-hidden="true"></i>
            <i v-if="singleChat.status === 'processed' && singleChat.userId === userId"
               class="fa fa-pencil" aria-hidden="true"></i>
          </div>
          <div>{{ singleChat.lastStatusUpdateTimestamp | formatDate }}</div>
          <div v-if="singleChat.status === 'open'"><i class="fa fa-circle circle-orange"></i>
            offen
          </div>
          <div v-if="singleChat.status === 'processed'"><i class="fa fa-circle online"></i>
            in Bearbeitung
          </div>
          <div v-if="singleChat.status === 'closed'"><i class="fa fa-circle circle-grey"></i>
            geschlossen
          </div>
          <div v-if="singleChat.groupId"><i class="fa fa-check-circle"></i>
            <div v-for="group in userGroups">
              <p v-if="singleChat.groupId === group.id">
                {{ group.name }}
              </p>
            </div>
          </div>
          <div v-if="!singleChat.groupId"><i class="fa fa-times-circle circle-grey"></i>
            keine
          </div>
          <div class="preview" @click.stop="handleOverlay(singleChat)">
            <i v-if="!singleChat.showOverlay" class="fa fa-search"></i>
            <i v-else class="fa fa-window-close"></i>
          </div>
          <Buttongroup v-if="!isAdmin" :isWatched="hasWatchers(singleChat)" :singleChat="singleChat"
                       :choosenChats="choosenChats" :userId="userId"
                       @selfassign="selfAssignChat(singleChat, index)"
                       @readonly="setReadOnly(singleChat,index)"
                       @unset-readonly="unsetReadOnly(singleChat, index)"
                       @groupoverlay="setGroupoverlay">
          </Buttongroup>
          <p class="bg-danger" v-if="isAdmin">keine Aktionen für Administrator</p>
        </div>
      </div>
    </div>
    <div v-if="allClientMessages.length === 0" class="bg-danger">Aktuell gibt es keine neuen Chatanfragen mit ihren
      Filterkriterien!
    </div>
  </div>
</template>


<script>
import fb from '../firebase/init';
import ActionOverlay from "../components/ActionOverlay";
import GroupOverlay from "../components/GroupOverlay";
import Message from "./Message";
import Chatfilter from "./Chatfilter";
import Multiselect from 'vue-multiselect';
import Paginate from 'vuejs-paginate';
import Chatcontrols from "./Chatcontrols";
import Buttongroup from "./Buttongroup";
import Tableheader from "./Tableheader";
import {collection, onSnapshot, query} from "firebase/firestore";

export default {
  name: 'ChatsOverview',
  props: ['userId', 'userName', 'userGroups', 'clientGroups', 'keywords', 'isAdmin'],
  components: {
    ActionOverlay,
    GroupOverlay,
    Chatfilter,
    Multiselect,
    Paginate,
    Message,
    Chatcontrols,
    Buttongroup,
    Tableheader
  },
  computed: {
    allClientMessages: function () {
      return this.$store.getters.getAllClientMessages;
    },
    sortedClientChats: function () {
      return this.allClientMessages.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      }).filter((row, index) => {
        let start = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return true;
      });
    },
    user: function () {
      return {
        id: this.userId,
        name: this.userName,
        groups: this.userGroups
      }
    }
  },
  data() {
    return {
      choosenChats: [],
      sidebar: false,
      multiAssign: false,
      multiWatch: false,
      action: null,
      currentSort: 'name',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1,
      showSinglechatOverlay: false,
      hoverChat: null,
      overlayChecked: false,
      actions: [
        {name: "Mir zuweisen", action: 'me'},
        {name: "Gruppe zuweisen", action: 'group'},
        {name: "Gruppenzuweisung löschen", action: 'delete_group'},
        {name: "Chats beobachten", action: 'watch'},
      ],
    }
  },
  beforeUpdate() {
    if (this.currentPage > Math.ceil(this.allClientMessages.length / this.pageSize)) {
      this.currentPage = 1;
    }
  },
  methods: {
    multiAction: function () {
      switch (this.action.action) {
        case 'me':
          this.selfAssignMultipleChats(this.choosenChats);
          break;
        case 'watch':
          this.watchMultipleChats(this.choosenChats);
          break;
        case 'delete_group':
          this.removeGroupAllocation(this.choosenChats);
          break;
      }
      this.clearChosenChats();
    },
    removeGroupAllocation: function (chats) {
      chats.forEach((chat) => {
          this.$store.getters.getFireStore.updateChatGroupId(chat, "");
          this.setSuccess('Die Gruppenzuweisung von ' + chat.fullCustomerName + ' wurde erfolgreich entfernt!');
    });
    },
    sort: function (s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.allClientMessages.length) this.currentPage++;
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--;
    },

    selfAssignChat: function (singleChat) {
      this.assign(singleChat);
    },
    selfAssignMultipleChats: function (chats) {
      chats.forEach((singleChat) => {
        this.assign(singleChat);
      });
      this.clearChosenChats();
    },
    assign: function (chat) {
      this.$store.getters.getFireStore.assign(chat, this.user);
      this.setSuccess('Der Chat mit ' + chat.fullCustomerName + ' wurde ihnen erfolgreich zugewiesen!');
      this.$emit('reload');
    },
    handleClick(singleChat) {
      const choosenIds = this.choosenChats.map(choosenChat => choosenChat.customerId);
      if (choosenIds.indexOf(singleChat.customerId) === -1) {
        this.choosenChats.push(singleChat);
        this.$set(singleChat, 'selected', true);
      } else {
        let index = choosenIds.indexOf(singleChat.customerId);
        this.choosenChats.splice(index, 1);
        this.$set(singleChat, 'selected', false);
      }
    },
    closeMultiAction: function () {
      this.choosenChats.forEach((singleChat) => {
        this.$set(singleChat, 'selected', false);
      });
      this.choosenChats = [];
    },
    removeChat: async function (chat, index) {
      this.choosenChats.splice(index, 1);
      this.allClientMessages.forEach(singleChat => {
        if (singleChat.customerId === chat.customerId) {
          this.$set(singleChat, 'selected', false);
        }
      });
      await this.$nextTick();
    },
    clearChosenChats: function () {
      this.choosenChats = [];
      this.action = null;
    },
    updateChats: function (chats) {
      this.clearChosenChats();
    },
    setReadOnly: function (chat) {
      this.$store.getters.getFireStore.setReadOnly(chat, this.user);
      this.clearChosenChats();
    },
    watchMultipleChats: function (chats) {
      chats.forEach((chat) => {
        this.setReadOnly(chat);
        this.setSuccess('Der Chat von' + chat.fullCustomerName + ' befindet sich nun auf deiner Beobachtungsliste');
      });
    },
    hasWatchers: function (chat) {
      return this.$store.getters.getFireStore.hasWatchers(chat, this.user);
    },
    unsetReadOnly: function (chat) {
      console.log("ijo");
      this.clearChosenChats();
      this.$store.getters.getFireStore.unsetReadOnly(chat, this.user);
    },
    highlight(text) {
      return text.replace(new RegExp(this.keywords, 'gi'), '<span class="highlighted">$&</span>');
    },
    setError: function (msg) {
      this.$emit('error', msg)
    },
    setSuccess: function (msg) {
      this.$emit('success', msg)
    },
    handleOverlay: function (singleChat) {
      if (!singleChat.showOverlay) {
        const basePath = singleChat.clientId.toString() + '/' + singleChat.customerId.toString();
        const messageCollection = collection(this.$store.getters.getFireStore.store, basePath + '/messages');
        const q = query(messageCollection);
        const subscription = onSnapshot(q, async (querySnapshot) => {
          this.$set(singleChat, 'messages', querySnapshot.docs.map(doc => doc.data()).sort((a, b) => a.timestamp - b.timestamp));
        });
      }
      this.$set(singleChat, 'showOverlay', !singleChat.showOverlay);
    },
    setGroupoverlay: function () {
      this.action = {name: "Gruppe zuweisen", action: 'group'};
    }
  },
  watch: {
    allClientMessages() {
      const choosenIds = this.choosenChats.map(choosenChat => choosenChat.customerId);
      this.allClientMessages.forEach(singleChat => {
        if (choosenIds.indexOf(singleChat.customerId) !== -1) {
          this.$set(singleChat, 'selected', true);
        }
      });
    }
  }
}
</script>

<style lang="scss">
body {
  height: auto !important;

  @-webkit-keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }

  @keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }

  .multiheader {
    display: flex;
    justify-content: space-between;
  }

  button {
    z-index: 101;
  }

  .fa-check-circle {
    color: green;
  }

  .fa-times-circle {
    color: red;
  }

  .multiselect {
    margin: 5px 0 5px 0;
    z-index: 9991;
  }

  .multiactions {
    margin-top: 15px;
    background-color: #ebebeb;
    border-radius: 7px;
    padding: 15px;

    h4 {
      padding: 3px 6px;
    }

    .choosenCustomers {
      margin: 0 0 15px 0;
    }
  }

  .choosenCustomers {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .choosenItem {
    border: 1px solid;
    border-color: #676A6C;
    border-radius: 7px;
    padding: 4px 4px 4px 4px;
    margin: 0 4px 0 4px;
  }

  .table {
    padding: 0 5px;
  }

  .tableContent {
    display: flex;
    width: 100%;
  }


  .tableContent {
    flex-wrap: wrap;
    cursor: pointer;
    padding: 10px 15px 10px 10px;


    .chatItem {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      width: 100%;
      margin: 0 0 15px 0;
      border-bottom: 1px solid #ebebeb;
      transition: transform 500ms ease;


      > div {
        width: calc(16.6% - 5px);

        &.preview {
          .fa-search {
            font-size: 16px;
          }
        }

        > div {
          display: inline-block;
        }
      }

      &.chatOverlay {
        z-index: 9993;

        .overlay {
          display: block;
          min-height: 300px;
        }
      }

      &.highlight {
        background: rgba(233, 76, 11, 0.05) !important;
        box-shadow: 0 0 1px 0 rgba(233, 76, 11, 1) !important;
        color: #000;
      }

      &:hover {
        transform: translateX(10px);
      }
    }
  }

  .overlay {
    padding-top: 25px;
    border-radius: 7px;
    position: fixed;
    top: 0;
    right: 0;
    width: 25vw;
    height: 200px;
    background-color: #fff;
    z-index: 999;
    overflow: hidden;
    -webkit-box-shadow: 8px 8px 47px -15px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 8px 8px 47px -15px rgba(0, 0, 0, 0.75);
    box-shadow: 8px 8px 47px -15px rgba(0, 0, 0, 0.75);
    transform: translateY(-310px);

    &.chat {
      width: 32vw !important;
      margin: 0 !important;
    }

    .overlay__headline {
      color: #fffff1;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999999;
      background-color: #3b3b3b;
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .chat-history {
      .message {
        margin-top: 30px;
      }
    }

    .messages {
      height: 100%;
      width: 100%;
    }

  }

  .bg-danger {
    padding: 15px;
    border-radius: 3px;
  }

  .circle-grey {
    color: #64696D;
  }

  .circle-orange {
    color: #ffa500;
  }
}

</style>
